// extracted by mini-css-extract-plugin
export default {"bar":"SignUp-bar-7c308b24a103534ca30e24dd3b5da3cb","title":"SignUp-title-f5d08362e4f55209c429fcbb38f4128a","header":"SignUp-header-b0a0b7f73be6ecb9a0320d281eab7c03"};